<template>
  <div>
    <search-invoice @submit="submitSearch" />

    <a-table
      :scroll="{ x: 'max-content' }"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :pagination="false"
      row-key="id"
      @change="sortChange"
    >
      <span slot="actions" slot-scope="text, record">
        <a-space>
          <a @click="showInvoicedModal(record)" v-if="record.status_slug === 'un_invoiced'">开票</a>
          <a @click="showDetailModal(record)" v-if="record.status_slug === 'invoiced'">详情</a>
          <a @click="showOperationHistoryModal(record.id)">操作历史</a>
        </a-space>
      </span>
    </a-table>

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />

    <!-- 开票模态框 -->
    <detail
      v-if="isShowDetailModal"
      :visible.sync="isShowDetailModal"
      :record="detailingRecord"
      @completed="fetchData"
    />

    <operation-history-list-modal
      v-if="isShowOperationHistoryModal"
      :reference-id="showingOperationHistoryId"
      reference-type="Invoice"
      :visible.sync="isShowOperationHistoryModal"
    />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import SearchInvoice from '@/views/invoices/Search'
import { findInvoicesList } from '@/api/invoice'

export default {
  name: 'InvoiceList',
  components: {
    Pagination,
    SearchInvoice,
    Detail: () => import('@/views/invoices/Detail'),
    OperationHistoryListModal: () => import('@/views/operation_histories/Modal')
  },
  data() {
    return {
      query: { status: 'un_invoiced' },
      data: [],
      loading: true,
      isShowDetailModal: false, // 是否显示详情表单弹窗
      detailingRecord: {}, // 正在编辑的记录id
      showingOperationHistoryId: 0,
      isShowOperationHistoryModal: false,
      pagination: {
        total_count: 0
      },
      sort: {
        sort_field: '',
        sort_order: ''
      }
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    columns() {
      return [
        {
          title: '申请时间',
          dataIndex: 'apply_time',
          width: 180,
          fixed: 'left',
          sorter: true,
          sortOrder: this.sort.sort_field === 'apply_time' ? this.sort.sort_order : false
        },
        {
          title: '用户姓名',
          width: 90,
          dataIndex: 'user_name'
        },
        {
          title: '电话',
          width: 200,
          dataIndex: 'phone_number'
        },
        {
          title: '发票形式',
          width: 200,
          dataIndex: 'invoice_type'
        },
        {
          title: '发票金额(元)',
          width: 200,
          dataIndex: 'fee'
        },
        {
          title: '状态',
          width: 80,
          dataIndex: 'status'
        },
        {
          title: '操作',
          width: 220,
          fixed: 'right',
          dataIndex: 'actions',
          scopedSlots: { customRender: 'actions' }
        }
      ]
    }
  },
  methods: {
    showDetailModal(record) {
      this.detailingRecord = record
      this.isShowDetailModal = true
    },

    showInvoicedModal(record) {
      this.detailingRecord = record
      this.isShowDetailModal = true
      // this.$warning({
      //   title: '开票功能还在开发中!',
      //   content: ''
      // })
    },

    // 显示操作历史
    showOperationHistoryModal(id) {
      this.showingOperationHistoryId = id
      this.isShowOperationHistoryModal = true
    },

    submitSearch(search) {
      // 重置排序
      this.sort = this.$options.data().sort
      // 赋值搜索条件，保留 per_page
      this.query = Object.assign({},
        this.$options.data().query,
        { per_page: this.query.per_page },
        search)
      this.fetchData()
    },

    sortChange(pagination, filters, sorter) {
      this.sort.sort_field = sorter.field
      this.sort.sort_order = sorter.order
      // 跳转第一页
      this.query.page = 1
      this.fetchData()
    },

    fetchData() {
      this.loading = true
      findInvoicesList(Object.assign({}, this.query, this.sort)).then((res) => {
        if (res.code === 0) {
          this.data = res.data
          this.pagination = res.pagination
        }
        this.loading = false
      })
    }
  }
}
</script>
